export default __webpack_public_path__ + "static/media/Estimate_09.37512251.png";